import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToReservation = () => {
    const element = document.querySelector('#reservation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-[#FAF8F5] overflow-hidden"
      data-testid="hero-section"
    >
      {/* Decorative Elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Large circle top right */}
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full border border-[#8B2942]/10" />
        <div className="absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full border border-[#8B2942]/15" />
        
        {/* Large circle bottom left */}
        <div className="absolute -bottom-60 -left-60 w-[700px] h-[700px] rounded-full border border-[#8B2942]/10" />
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full border border-[#8B2942]/15" />
        
        {/* Rose watermark */}
        <svg 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] opacity-[0.03]" 
          viewBox="0 0 100 100" 
          fill="#8B2942"
        >
          <circle cx="50" cy="35" r="25" />
          <ellipse cx="30" cy="50" rx="18" ry="22" />
          <ellipse cx="70" cy="50" rx="18" ry="22" />
          <ellipse cx="40" cy="70" rx="16" ry="20" />
          <ellipse cx="60" cy="70" rx="16" ry="20" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl">
        <h1 
          className="font-['Playfair_Display'] text-5xl sm:text-6xl lg:text-8xl font-light tracking-wide mb-6 animate-fade-in-up"
          data-testid="hero-title"
        >
          <span className="text-[#8B2942]">PAVILLON</span>
          <span className="text-[#1A1A1D] block mt-2">de ROZE</span>
        </h1>
        
        <div className="section-divider mb-8 animate-fade-in animation-delay-200" />
        
        <p 
          className="text-lg md:text-xl text-[#6B6B6B] tracking-widest uppercase mb-12 animate-fade-in-up animation-delay-400"
          data-testid="hero-subtitle"
        >
          {t('hero.subtitle')}
        </p>

        <button
          onClick={scrollToReservation}
          className="btn-gold inline-flex items-center gap-3 px-8 py-4 border border-[#8B2942] text-[#8B2942] uppercase tracking-widest text-sm hover:bg-[#8B2942] hover:text-white transition-all duration-300 animate-fade-in-up animation-delay-600"
          data-testid="hero-cta-btn"
        >
          {t('hero.cta')}
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-[#8B2942]" size={32} />
      </div>
    </section>
  );
};

export default Hero;
